import React from "react";
import Button from "components/UI/Button";
import styles from "./styles.module.scss";
import { track } from "../../../utils/amplitude";
import FlagSVG from "./flag.svg";
import Link from "next/link";

const GetStarted = () => {
  return (
    <div className="container">
      <div className={`${styles.started} get-started-block`}>
        <div>
          <h2>Getting started is easy. Try Apphud today</h2>
          <p>
            Build better apps with Apphud. No credit card required. Free for
            startups.
          </p>
          <div className={styles.btns}>
            <a
              href="https://app.apphud.com/sign_up"
              onClick={() =>
                track("sign_up_button_clicked", { block: "bottom_link" })
              }
            >
              <Button title="Start for Free" />
            </a>
            <Link
              href="/demo"
              target="_blank"
              onClick={() =>
                track("demo_request_link_clicked", { block: "bottom_link" })
              }
            >
              <Button title="Get a demo" transparent />
            </Link>
          </div>
        </div>

        <div>
          <FlagSVG />
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
